import React from "react";
import BlogHero from "../components/blog/BlogHero";
import BlogList from "../components/blog/BlogList";

const Blog = () => {
  return (
    <div className="w-full overflow-x-hidden">
      <BlogHero />
      <BlogList />
    </div>
  );
};

export default Blog;
